import type { RootState } from '@/store';

export const selectShareContext = (state: RootState) => state.compartilhamento.currentContext;
export const selectSharePeople = (state: RootState) => state.compartilhamento.people;
export const selectShareSectorAccess = (state: RootState) => state.compartilhamento.sectorAccess;
export const selectShareSectors = (state: RootState) => state.compartilhamento.sectors;
export const selectShareSuggestions = (state: RootState) => state.compartilhamento.suggestions;
export const selectShareInviteLink = (state: RootState) => state.compartilhamento.inviteLink;
export const selectShareLoadingContext = (state: RootState) =>
  state.compartilhamento.isLoadingContext;
export const selectShareSubmitting = (state: RootState) => state.compartilhamento.isSubmitting;
export const selectShareSearchingSuggestions = (state: RootState) =>
  state.compartilhamento.isSearchingSuggestions;
export const selectShareContextError = (state: RootState) => state.compartilhamento.contextError;
export const selectShareSubmitError = (state: RootState) => state.compartilhamento.submitError;

export const selectSectorsSummary = (state: RootState) => state.compartilhamento.sectorsSummary;
export const selectSectorsSummaryLoading = (state: RootState) =>
  state.compartilhamento.isLoadingSummary;
export const selectSectorsSummaryError = (state: RootState) => state.compartilhamento.summaryError;

export const selectInvitePreview = (state: RootState) => state.compartilhamento.invitePreview;
export const selectInviteLoading = (state: RootState) => state.compartilhamento.isLoadingInvite;
export const selectInviteSubmitting = (state: RootState) =>
  state.compartilhamento.isSubmittingInvite;
export const selectInviteError = (state: RootState) => state.compartilhamento.inviteError;
export const selectInviteAccepted = (state: RootState) => state.compartilhamento.inviteAccepted;
